import PostOutcomeTrackerDetailedMetrics from '../../services/adapters/outcomeTrackerDetailedMetrics';
import PostOutcomeTrackerBenefitTakeup from '../../services/adapters/outcomeTrackerBenefitTakeup';
import PostOutcomeTrackerPensionCredit from '../../services/adapters/outcomeTrackerPensionCredit';
import PostOutcomeTrackerHeadlines from '../../services/adapters/outcomeTrackerHeadlines';
import { FrontendFilterValue } from '../../types/filters.type';
import { OutcomeTrackerHeadlines } from '../../types/global';
import { OutcomeDetailedMetricsTab } from '../../types/table.type';

const runAnalysis = async (
  selectedCohort: string,
  campaign: string,
  householdReferences: FrontendFilterValue[],
  snapshots: { start: string; end: string },
  handleHeadlinesRequest: (asyncPromise: Promise<OutcomeTrackerHeadlines>) => Promise<OutcomeTrackerHeadlines | null>,
  handleDetailedMetricsRequest: (asyncPromise: Promise<OutcomeDetailedMetricsTab[]>) => Promise<OutcomeDetailedMetricsTab[] | null>,
  handleBenefitTakeupRequest: (asyncPromise: Promise<OutcomeDetailedMetricsTab[]>) => Promise<OutcomeDetailedMetricsTab[] | null>,
  handlePensionCreditRequest: (asyncPromise: Promise<OutcomeDetailedMetricsTab>) => Promise<OutcomeDetailedMetricsTab | null>,
  savedCohortId = '',
) => {
  const analysisRequest = {
    selectedCohort,
    campaign,
    householdReferences,
    snapshots,
    savedCohortId,
  };
  const headlinesResponse = new PostOutcomeTrackerHeadlines().adaptResponse(analysisRequest);
  const detailedMetricsResponse = new PostOutcomeTrackerDetailedMetrics().adaptResponse(analysisRequest);
  const benefitTakeupResponse = new PostOutcomeTrackerBenefitTakeup().adaptResponse(analysisRequest);
  const pensionCreditResponse = new PostOutcomeTrackerPensionCredit().adaptResponse(analysisRequest);

  await Promise.all([
    handleHeadlinesRequest(headlinesResponse),
    handleDetailedMetricsRequest(detailedMetricsResponse),
    handleBenefitTakeupRequest(benefitTakeupResponse),
    handlePensionCreditRequest(pensionCreditResponse),
  ]);
};
export default runAnalysis;
